exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".product-status-link{display:-ms-flexbox;display:flex;-ms-flex-flow:row nowrap;flex-flow:row nowrap;padding-bottom:5px}.product-status-link .product-status-label{color:#aaa;margin-right:10px;width:auto}.product-status-link .status{-ms-flex-align:start;align-items:flex-start;display:-ms-flexbox;display:flex}.product-status-link .status .status-primary{margin-right:10px}.product-status-link .status .button-text{line-height:1;padding-top:1px}.product-status-link .dot-icon-red,.product-status-link .dot-icon-yellow{-ms-flex:0 0 auto;flex:0 0 auto;margin:2px 5px 2px 0}.product-status-link .status button{font-weight:700}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/sass-loader!./src/product/shared/components/product-status-link.scss
// module id = 5154
// module chunks = 0